module.exports = __webpack_public_path__ + "8b543d5ef3aa9839c7aa3c4368b81217.glb";